import * as actionTypes from "../actions/index";
import {LOCATION_CHANGE} from "connected-react-router";

const defaultState = {
    wordingCategories: {
        byId: {},
        allIds: [],
    },
    fetching: false
};

const fetchWordingCategories = (state, action) => {
    return {
        ...state,
        fetching: true,
    }
};

const fetchWordingCategoriesSuccess = (state, action) => {
    const byId = action.payload.body
        .reduce((acc, cur) => {
            return {
                ...acc,
                [cur.id]: cur,
            }
        }, {})
    const allIds = action.payload.body.map(e => e.id);
    return {
        ...state,
        wordingCategories: {
            byId,
            allIds,
        },
        fetching: false,
    }
};

const fetchWordingCategoriesFailed = (state, action) => {
    return {
        ...state,
        fetching: false
    }
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_WORDING_CATEGORIES: return fetchWordingCategories(state, action);
        case actionTypes.FETCH_WORDING_CATEGORIES_SUCCESS: return fetchWordingCategoriesSuccess(state, action);
        case actionTypes.FETCH_WORDING_CATEGORIES_FAILED: return fetchWordingCategoriesFailed(state, action);
        case LOCATION_CHANGE: return defaultState;
        case actionTypes.LOGOUT: return defaultState;
        default: return state;
    }
};